<div class="dialog-title">
  <h1 *ngIf="data.title">
    {{ data.title }}
  </h1>

  <button
    mat-icon-button
    (click)="close()"
    class="close-btn"
    *ngIf="data.isCloseBtn"
  >
    <svg-icon name="cross" class="stroked error-color"></svg-icon>
  </button>
</div>

<div class="dialog-content">
  <ng-content select="[body]"></ng-content>
</div>

<div class="dialog-actions">
  <ng-content select="[actions]"></ng-content>
</div>
